var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-150 -34)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m52.257 0c-5.5856 0-10.114 4.3396-10.114 9.6929 0 5.3532 4.5287 9.6929 10.114 9.6929 5.5856 0 10.114-4.3396 10.114-9.6929 0-5.3532-4.5287-9.6929-10.114-9.6929m-0.0081305 18.56c-4.3124 0-6.1596-3.8682-6.1596-8.8754 0-4.9939 1.8261-8.8572 6.1417-8.8572s6.1938 3.8649 6.1938 8.8572c0 5.0071-1.8635 8.8754-6.1759 8.8754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "m117.21 16.143c-1.8269 1.6957-3.4686 2.2576-5.6675 2.2543-3.4819-0.0049436-6.3884-3.3815-6.3884-8.7058 0-5.2419 2.9065-8.6745 6.3884-8.6794 2.1989-0.0032958 3.7051 0.4647 5.6675 2.2312l0.78863-0.72177c-2.1956-1.8769-4.0258-2.5213-6.5736-2.5213-6.0462 0-10.284 4.3389-10.284 9.6912s4.1895 9.6945 10.284 9.6945c2.5478 0 4.378-0.64432 6.5736-2.5213l-0.78863-0.72177z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "a",
    points: "94.4 0 90.186 0 90.186 18.543 94.369 18.543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m76.857 0h-7.7426v18.543h3.721v-8.5398c0.074713 0.0016461 1.2214 0.034567 2.3778 0.034567 3.7698 0 7.3869-1.381 7.3869-5.0188 0-3.3234-2.8456-5.0188-5.7432-5.0188m-2.3421 9.2245c-1.0703 0-1.5592-0.031275-1.681-0.037859v-8.3784h1.681c2.3827 0 4.4422 0.94484 4.4422 4.209 0.0016234 3.3349-2.7075 4.2073-4.4422 4.2073"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.171 0.84286 0 0.84286 0 2.1588 5.6909 2.1588 5.6909 19.386 9.3917 19.386 9.4175 2.1588 15.171 2.1588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.348 13.476c-1.0518-1.6624-1.7389-2.5322-2.3858-2.9384 2.4036-0.5936 4.3458-1.9222 4.3458-4.6813 0-3.3199-2.8262-5.0135-5.704-5.0135h-7.6898v18.523h3.6957v-8.5307c0.10324 0.0065772 0.67751 0.021376 1.5454 0.031242 0.87109 0.57057 1.4921 1.5128 2.6746 3.5533 1.4002 2.4138 2.5681 4.9658 4.749 4.9658l4.1925-0.018087v-0.2302c-2.118-0.24007-4.2441-3.8-5.4233-5.6614m-7.7365-11.826h1.6696c2.3665 0 4.4119 0.94383 4.4119 4.2045 0 3.3314-2.6907 4.2045-4.4119 4.2045-1.063 0-1.5244-0.027953-1.6696-0.037819v-8.3712z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b854361d063c9d409454a52e5ac05b09.svg";
export { ForwardRef as ReactComponent };